import styled from '@emotion/styled';
import {
  mixinFlexboxColumn,
  mixinSubHeading,
  mixinSVGIcon,
  mixinTruncate,
} from 'webapp-lib/styling';

import {Props} from './Card';

export const InfoContainer = styled.div`
  display: flex;
  align-items: center;
  margin: calc(var(--gutter-tiny) * -1);
`;

export const TitleIconWrapper = styled.div`
  ${mixinFlexboxColumn};
  justify-content: center;

  svg {
    ${mixinSVGIcon}
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  margin: calc(var(--gutter-tiny) * -1);
`;

export const TooltipContent = styled.span`
  min-width: 0;
  ${mixinTruncate};
`;

export const TitleLabel = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  column-gap: var(--gutter-small);
  ${mixinTruncate};
  min-width: 0;
`;

export const TitleLabelTopRow = styled.div`
  display: flex;
  gap: var(--gutter-small);
  max-width: 100%;
`;

export const TitleWrapper = styled('div', {
  shouldForwardProp: (prop: string): boolean =>
    !['hasChildrenAndTitle'].includes(prop),
})<{hasChildrenAndTitle: boolean}>`
  padding-bottom: ${({hasChildrenAndTitle}): string =>
    hasChildrenAndTitle ? 'var(--gutter-very-tiny)' : '0'};
`;

export const Title = styled.h3<{hasChildren: boolean}>`
  display: grid;
  grid-column-gap: var(--gutter-tiny);
  grid-template-columns: auto min-content;
  ${mixinSubHeading};
  justify-content: space-between;
  padding-bottom: ${({hasChildren}): string =>
    hasChildren ? 'var(--gutter-little)' : '0'};

  > a {
    font-size: inherit;
    font-weight: inherit;
  }

  ${Actions} {
    gap: var(--gutter-tiny);

    button {
      padding-bottom: var(--gutter-tiny);
      padding-top: var(--gutter-tiny);
    }

    svg {
      ${mixinSVGIcon}
    }
  }

  ${InfoContainer} {
    float: right;
    width: 28px;
    height: 28px;

    svg {
      ${mixinSVGIcon};
      fill: var(--color-alerts-error);
    }
  }
`;

export const TitleUpperText = styled.div`
  color: var(--color-core-primary);
  font-size: var(--font-size-tiny);
  margin-bottom: var(--gutter-tiny);
  max-width: 100%;
  ${mixinTruncate}
`;

export const Subtext = styled.div`
  color: var(--color-core-black);
  font-size: var(--font-size-tiny);
  margin-top: var(--gutter-very-tiny);
  max-width: 100%;
  ${mixinTruncate}
`;

export const StyledCard = styled('div', {
  shouldForwardProp: (prop: string) => prop !== 'highlighted',
})<Props>`
  padding: var(--gutter);
  border: var(--regular-border-width) solid
    ${({highlighted}) =>
      highlighted
        ? 'var(--color-buttons-primary-hover)'
        : 'var(--color-box-border)'};
  border-radius: 2px;
  position: relative;
  display: flex;
  flex-direction: column;

  ${({action}): string => (action == null ? '' : 'cursor: pointer;')}
  :focus-within {
    border: var(--regular-border-width) solid var(--color-menu-border-focus);
  }

  &.no-title {
    ${Title} {
      height: 32px;
      margin-bottom: -23px;
    }
  }

  &.inactive {
    border: none;
    background-color: var(--color-core-grey-light);
  }

  &.error {
    border: var(--card-error-border-width) solid var(--card-error-border-color);
  }
`;
